import { apm, init } from '@elastic/apm-rum';
import { useEffect } from 'react';
import { jsx, Fragment } from 'react/jsx-runtime';

/**
 * Helper method to get the global instance of
 * apm that is initialized using the APMProvider
 */
function getAPM() {
  return apm;
}

/**
 * Hook to get the global instance of APM that
 * has been initialized using the APMProvider
 */
function useAPM() {
  return getAPM();
}

function useInitAPM(props) {
  useEffect(() => {
    if (props.serviceVersion !== 'local') {
      init({
        ...props,
        active: true
      });
    }
  }, [props]);
}

function APMProvider({
  children,
  ...props
}) {
  useInitAPM(props);
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
}

function useTransaction(name, type) {
  useEffect(() => {
    const transaction = apm.startTransaction(name, type);
    return () => {
      if (transaction) {
        transaction.end();
      }
    };
  }, [name, type]);
}

function APMTransaction({
  children,
  name,
  type
}) {
  useTransaction(name, type);
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
}

export { APMProvider, APMTransaction, getAPM, useAPM };
//# sourceMappingURL=index.js.map
